export const ROUTES = {
	home: "/",
	characters: "/characters",
	plot: "/plot",
	details: "/characters/details/:slug",
	resources: "/resources",
	adaptations: "/adaptations",
	community: "/community",
	artifacts: "/artifacts",
};
